import { Pipe, PipeTransform } from "@angular/core";
import { SearchResultType } from "src/app/common/services/config.service";

@Pipe({
  name: "searchTypeToLabel",
  standalone: true,
})
export class SearchTypeToLabelPipe implements PipeTransform {
  //TODO i18n
  private readonly typeToLabel: Record<SearchResultType, string> = {
    ARTICLE: "Article",
    SPEECH2TEXT_AUDIO: "Audio&Podcast",
    SPEECH2TEXT_VIDEO: "Play RTS",
    AUDIOVISUAL_MEDIA_AUDIO: "Audio",
    AUDIOVISUAL_MEDIA_VIDEO: "Video",
    AGENCY_NEWS: "News d'agence",
    INSTAGRAM_POST: "Instagram",
  };

  transform(value: SearchResultType | undefined): string {
    if (!value) {
      return "";
    }
    return this.typeToLabel[value] ?? value;
  }
}
